<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "./assets/style/vue.scss";
@import "./assets/iconfont/iconfont.css";
#app {
  height: 100%;
}
.subheadlines {
  display: flex;
  align-items: center;
  position: relative;
  h2 {
    font-weight: bold;
    color: #000;
  }
  h3 {
    font-weight: bold;
    text-transform: uppercase;
    color: #d1d1d1;
  }
}
.subheadlines::after {
  content: " ";
  flex: 1;
  display: block;
  height: 0.0625rem /* 1/16 */;
  background-color: #c7c7c7;
}
/*媒体查询*/
/*屏幕宽度大于1024px的时候执行里面的css*/
@media only screen and (min-width: 1024px) {
  .subheadlines {
    h2 {
      margin-right: 3.125rem /* 50/16 */;
      font-size: 1.875rem /* 30/16 */;
      letter-spacing: 1.25rem /* 20/16 */;
    }
    h3 {
      margin-right: 2.5rem /* 40/16 */;
      font-size: 1.5rem /* 24/16 */;
      letter-spacing: 1.25rem /* 20/16 */;
    }
  }
  .desc {
    margin-top: 5rem /* 80/16 */;
    font-size: 1.25rem /* 20/16 */;
    line-height: 2rem /* 32/16 */;
    letter-spacing: 0.125rem /* 2/16 */;
  }
}
/*媒体查询*/
/*屏幕宽度小于1024px的时候执行里面的css*/
@media only screen and (max-width: 1024px) {
  .subheadlines {
    flex-direction: column;
    h2 {
      font-size: 1.0625rem /* 17/16 */;
      letter-spacing: 0.2rem;
    }
    h3 {
      margin-top: 0.6875rem /* 11/16 */;
      font-size: 1rem;
      font-weight: 800;
      color: #000;
      opacity: 0.3;
      letter-spacing: 0.1875rem /* 3/16 */;
    }
  }
  .subheadlines::after {
    content: " ";
    width: 11.375rem /* 182/16 */;
    position: absolute;
    top: 46%;
    opacity: 0.2;
    background-color: #000;
  }
  .desc {
    margin-top: 2rem /* 32/16 */;
    padding: 0 1.125rem /* 18/16 */;
    font-size: 0.875rem /* 14/16 */;
    line-height: 1.5rem /* 24/16 */;
    letter-spacing: 0.0625rem /* 1/16 */;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue